import { type AxiosRequestConfig, getApiClient } from 'apiClient';
import { routes } from './routes';

type BodyRequest = {
  checksum: string;
  chunkNumber: number;
};

type UploadInfoResponse = { type: 'media' } | { type: 's3'; url: string };

export const getUploadInfo = async ({
  body,
  config,
  mediaId,
}: {
  body: BodyRequest;
  config: AxiosRequestConfig;
  mediaId: string;
}) => getApiClient().post<UploadInfoResponse>(routes.chunkedUpload.chunk.uploadInfo(mediaId), body, config);
